export default "__VITE_ASSET__DdAcqDkQ__"